import {
  Compass, Handshake, PoundSterling, Scale, ShieldCheck,
  Users, Package, Landmark, type LucideIcon,
} from 'lucide-react';
import type { WorkspaceSection } from './types';

export const AREA_ICONS: Record<string, LucideIcon> = {
  strategy_market: Compass,
  commercial_gtm: Handshake,
  finance_reporting: PoundSterling,
  legal_risk: Scale,
  compliance_certification: ShieldCheck,
  people_organisation: Users,
  product_operations: Package,
  investor_readiness: Landmark,
};

export const isVisibleSection = (s: WorkspaceSection) => s.enabled || s.pending;

export const isPendingSection = (s: WorkspaceSection) => !s.enabled && !!s.pending;

export function findSection(sections: WorkspaceSection[], id: string): WorkspaceSection | null {
  const parts = id.split('.');
  let level: WorkspaceSection[] | undefined = sections;
  let found: WorkspaceSection | null = null;
  for (let i = 1; i <= parts.length; i++) {
    const want = parts.slice(0, i).join('.');
    found = level?.find(s => s.id === want) ?? null;
    if (!found) return null;
    level = found.subsections;
  }
  return found;
}
